import axios from "axios";
import apiUrls from "src/api";
import type { ReleaseFeedEntry } from "src/model/model";

export interface FetchReleaseFeedParams {
  limit?: number;
  offset?: number;
  surface?: "web" | "vr" | "both";
}

export async function fetchReleaseFeed(
  params: FetchReleaseFeedParams = {},
): Promise<ReleaseFeedEntry[]> {
  const response = await axios.get<ReleaseFeedEntry[]>(apiUrls.releases.feed, { params });
  return response.data;
}

export async function getUnreadCount(): Promise<{ count: number }> {
  const response = await axios.get<{ count: number }>(apiUrls.releases.unreadCount);
  return response.data;
}

export async function markSeen(): Promise<{ lastSeenReleaseId: number }> {
  const response = await axios.post<{ lastSeenReleaseId: number }>(apiUrls.releases.markSeen);
  return response.data;
}
